/**
 * @fileoverview Data Privacy Page component.
 * @summary Dedicated page for RGPD data management and account deletion.
 *
 * @package KaraoNow
 * @module apps/front/src/pages/DataPrivacyPage
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { useTranslation } from 'react-i18next'
import PageHeader from '../components/PageHeader.js'
import RGPDSection from './components/RGPDSection.js'

/**
 * @summary Data Privacy Page component.
 * @returns {React.ReactElement} Data privacy page.
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 */
export default function DataPrivacyPage() {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen bg-base-50 dark:bg-base-900">
      <PageHeader
        title={t('rgpd.pageTitle')}
        subtitle={t('rgpd.pageSubtitle')}
      />

      <div className="max-w-2xl mx-auto py-4">
        <RGPDSection />
      </div>
    </div>
  )
}

